module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-dining-philosophers.json
// module id = 815
// module chunks = 219147425318692